// One client-side permission vocabulary for navigation and route guards.
// API routes remain the source of truth, but this prevents a configured-hidden
// module from appearing in the sidebar or rendering through a bookmarked URL.

export const normalizeModuleName = (value) => String(value || "").trim().toLowerCase();

// Compatibility aliases let an older permission label continue to govern the
// same screen after the module catalogue was renamed. New Access Setup saves
// always use the current label; this prevents a deployment from unexpectedly
// hiding a screen from an existing role.
const MODULE_PERMISSION_ALIASES = {
  "catalog setup": ["crm catalog setup"],
  "hubspot archive": ["hubspot info", "hubspot emails info"],
};

export const readSessionUser = () => {
  try {
    const parsed = JSON.parse(sessionStorage.getItem("user_token") || "{}");
    return parsed && typeof parsed === "object" ? parsed : {};
  } catch {
    return {};
  }
};

export function moduleAccessForUser(user, moduleName) {
  const role = normalizeModuleName(user?.role || user?.userRole || user?.accessRole);
  const permissions = user?.access ?? user?.permissions ?? {};

  if (role === "superadmin" || role === "super admin" || permissions === "ALL") {
    return { view: true, edit: true };
  }

  if (!permissions || typeof permissions !== "object") {
    return { view: false, edit: false };
  }

  const expected = normalizeModuleName(moduleName);
  // Admin has the complete Email Tickets workflow by policy.  The API
  // enforces the same rule; this keeps the navigation and route guards in
  // sync even while an older browser session still holds a stale role map.
  if (role === "admin" && expected === "email tickets") {
    return { view: true, edit: true };
  }
  const acceptedNames = new Set([
    expected,
    ...(MODULE_PERMISSION_ALIASES[expected] || []),
  ]);
  const match = Object.entries(permissions).find(
    ([name]) => acceptedNames.has(normalizeModuleName(name))
  )?.[1];

  const view = match?.view === true || match?.view === 1 || match?.edit === true || match?.edit === 1;
  const edit = match?.edit === true || match?.edit === 1;
  return { view, edit };
}

export const canViewModule = (user, moduleName) => moduleAccessForUser(user, moduleName).view;

export const accessTypeForModule = (user, moduleName) =>
  moduleAccessForUser(user, moduleName).edit ? "Edit" : "View";

